<template>
    <span v-if="teams && teams.length" class="user-chip-container">
        <!-- First team -->
        <v-chip small>
            {{ teams[0] }}
        </v-chip>

        <!-- If exactly 2 teams, show the second team -->
        <v-chip small v-if="teams.length === 2">
            {{ teams[1] }}
        </v-chip>

        <!-- If more than 2 teams, show "+ n more" -->
        <v-chip 
            small 
            v-if="teams.length > 2" 
            :title="teams.slice(1).join(', ')"
        >
            + {{ teams.length - 1 }} more
        </v-chip>
    </span>
</template>

<script>
export default {
    props: ['teams']
}
</script>